<div *ngFor="let kodJazyk of kodJazykIN.split(', '); let index = index;"
  [ngClass]="{'mt-n2': index === 0}">

 <app-header-polozka
    [ngClass]="{'mt-n1': index === 0}"
    [typ]="typZaznamuTextu"
    [kodJazyk]="kodJazyk"
    [formularFormGroup]="formularFormGroup"
    [zobrazitCopyButton]="index === 0 && kodJazykIN.length > 2">
  </app-header-polozka>

  <div *ngIf="typZaznamuTextu.opakovanie === 'A'
        || (jeOpakovaniePodprogramu); else neopakovanaPolozka"
      formArrayName="name_{{typZaznamuTextu.id}}_{{kodJazyk}}">

    <!-- OPAKOVANE POLOZKY -->
        <div *ngFor="let controlFromArray of (mapaJazykovAFormArrays.get(kodJazyk)?.controls || []);
          let i = index; last as last">


      <!-- SWAPOVACI BUTTON -->
      <div class="d-flex">
        <button *ngIf="i > 0 && i < (mapaJazykovAFormArrays.get(kodJazyk)?.controls?.length || 0)"
          class="ms-auto"
          style="margin-top: -13px;"
          mat-icon-button
          type="button"
          (click)="vymenPolozky(i, kodJazyk)"
          [matTooltip]="getVymenitObsahPoloziekTooltip()"
          aria-label="Vymeniť obsah položiek">
          <mat-icon>swap_vert</mat-icon>
        </button>
      </div>

      <!-- VAZBA (STUPEN A TYP STUDIA POLOZKY) -->
      <div *ngIf="typZaznamuTextu.vazba === appStateService.VAZBA_STUPEN_TYP_STUDIA
          && index === 0"
        class="d-flex justify-content-end">

        <app-stupen-typ-studia
          [idTyp]="typZaznamuTextu.id"
          [poradieOpakovanejPolozky]="i+1">
        </app-stupen-typ-studia>

      </div>

      <div class="d-flex flex-row">



        <div *ngIf="typZaznamuTextu.opakovanie === 'A'" class="mt-3 me-2 h5">{{i+1}}.</div>

        <mat-form-field class="full-width" appearance="fill"
            [ngStyle]="{'margin-left':
              (typZaznamuTextu.opakovanie === 'A' && mapaJazykovAFormArrays.get(kodJazyk)!.length > 9 && i < 9) ? '.72rem' : ''}">
          <mat-label>{{getInputLabel(kodJazyk, typZaznamuTextu.idTypObjektu)}}</mat-label>
          @if (typZaznamuTextu.idTypObjektu === NON_NEGATIVE_INTEGER) {
            <input matInput type="number" step="1" min="0" inputmode="numeric"
              name="name_{{typZaznamuTextu.id}}_{{i}}_{{kodJazyk}}"
              id="name_{{typZaznamuTextu.id}}_{{i}}_{{kodJazyk}}"
              [formControlName]="i"
              [placeholder]="'getPlaceholderText(kodJazyk)'"
              autocomplete="disabled">

          } @else {
            <input matInput type="text"
              name="name_{{typZaznamuTextu.id}}_{{i}}_{{kodJazyk}}"
              id="name_{{typZaznamuTextu.id}}_{{i}}_{{kodJazyk}}"
              [formControlName]="i"
              [placeholder]="getPlaceholderText(kodJazyk)"
              autocomplete="disabled">
          }
          <button type="button" matSuffix mat-icon-button aria-label="Clear"
              (click)="vymazObsahPolozky(kodJazyk, i)"
              [matTooltip]="getZmazatTextTooltip()"
              [disabled]="typZaznamuTextu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <div *ngIf="last && (typZaznamuTextu.opakovanie === 'A'
            || appStateService.zobrazitButtonOpakovaniaPrePodprogram(typZaznamuTextu))" class="mt-2 ms-2">
          <button mat-mini-fab color="primary" type="button" (click)="pridatPolozku(kodJazyk)"
              [matTooltip]="getPridatPolozkuTooltip()"
              [disabled]="typZaznamuTextu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
            <mat-icon>add</mat-icon>
          </button>
        </div>


      </div>


      <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)
          && appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu, kodJazyk, i)"
        class="mb-2 font-italic pomocny-text-podprogramy"
        [ngClass]="{'ms-4': typZaznamuTextu.opakovanie === 'A', 'ms-1': typZaznamuTextu.opakovanie !== 'A'}">

        {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu, kodJazyk, i)}}
      </div>

      <!-- POLICKO PRE STUD. PROGRAMY ZAZNAMU TEXTU PODPROGRAMU A BUTTON PRE ICH VYBER -->
      <div *ngIf="appStateService.zobrazitButtonOpakovaniaPrePodprogram(typZaznamuTextu)"
        [ngClass]="{'mb-5': !last}">
        <app-studijne-programy-zaznamu
          [typZaznamuTextu]="typZaznamuTextu"
          [kodJazyk]="kodJazyk"
          [poradiePolozkyVoFormulari]="i+1"
          [mapaJazykovAFormArrays]="mapaJazykovAFormArrays">
        </app-studijne-programy-zaznamu>
      </div>

    </div>

  </div>

  <ng-template #neopakovanaPolozka>
    <div *ngIf="!typZaznamuTextu.idSkupina || typZaznamuTextu.idSkupina === 0;else skupinovaPolozka">

      <span *ngIf="typZaznamuTextu.uroven === 2
        && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty"
          class="text-warning" i18n>
          *položka je editovateľná len z úrovne fakulty
      </span>

      <mat-form-field class="full-width" appearance="fill">
        <mat-label>{{getInputLabel(kodJazyk, typZaznamuTextu.idTypObjektu)}}</mat-label>
          @if (typZaznamuTextu.idTypObjektu === NON_NEGATIVE_INTEGER) {
            <input matInput type="number" step="1" min="0"  inputmode="numeric"
              name="name_{{typZaznamuTextu.id}}_{{kodJazyk}}"
              id="name_{{typZaznamuTextu.id}}_{{kodJazyk}}"
              formControlName="name_{{typZaznamuTextu.id}}_{{kodJazyk}}"
              [placeholder]="getPlaceholderText(kodJazyk, NON_NEGATIVE_INTEGER)"
              autocomplete="disabled">

          } @else {
            <input matInput type="text"
              name="name_{{typZaznamuTextu.id}}_{{kodJazyk}}"
              id="name_{{typZaznamuTextu.id}}_{{kodJazyk}}"
              formControlName="name_{{typZaznamuTextu.id}}_{{kodJazyk}}"
              [placeholder]="getPlaceholderText(kodJazyk)"
              autocomplete="disabled">
          }
        <button type="button" matSuffix mat-icon-button aria-label="Clear"
            (click)="vymazObsahPolozky(kodJazyk)"
            [matTooltip]="getZmazatTextTooltip()"
            [disabled]="typZaznamuTextu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <!-- pomocny text pre polozku podprogramu -->
      <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)"
        class="ms-1 mb-2 font-italic pomocny-text-podprogramy">

        {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu)}}
      </div>

    </div>

    <ng-template #skupinovaPolozka>
      <div formArrayName="name_{{typZaznamuTextu.idSkupina}}_{{kodJazyk}}">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>{{getInputLabel(kodJazyk, typZaznamuTextu.idTypObjektu)}}</mat-label>
          @if (typZaznamuTextu.idTypObjektu === NON_NEGATIVE_INTEGER) {
            <input matInput type="number" step="1" min="0"  inputmode="numeric"
                name="name_{{typZaznamuTextu.id}}_{{typZaznamuTextu.idSkupina}}_{{indexPolozkyVoFormulari}}_{{kodJazyk}}"
                id="name_{{typZaznamuTextu.id}}_{{typZaznamuTextu.idSkupina}}_{{indexPolozkyVoFormulari}}_{{kodJazyk}}"
                [formControlName]="indexPolozkyVoFormulari"
                [placeholder]="getPlaceholderText(kodJazyk, NON_NEGATIVE_INTEGER)"
                autocomplete="disabled"
                readonly="{{readonlyPolozkyFormulara.includes(typZaznamuTextu.id)}}">

          } @else {
            <input matInput type="text"
                name="name_{{typZaznamuTextu.id}}_{{typZaznamuTextu.idSkupina}}_{{indexPolozkyVoFormulari}}_{{kodJazyk}}"
                id="name_{{typZaznamuTextu.id}}_{{typZaznamuTextu.idSkupina}}_{{indexPolozkyVoFormulari}}_{{kodJazyk}}"
                [formControlName]="indexPolozkyVoFormulari"
                [placeholder]="getPlaceholderText(kodJazyk)"
                autocomplete="disabled">
          }
          <button type="button" matSuffix mat-icon-button aria-label="Clear"
              (click)="vymazObsahPolozky(kodJazyk, indexPolozkyVoFormulari)"
              [matTooltip]="getZmazatTextTooltip()"
              [disabled]="(typZaznamuTextu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty)
                || readonlyPolozkyFormulara.includes(typZaznamuTextu.id)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <!-- pomocny text pre polozku podprogramu -->
        <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)"
          class="ms-1 mb-2 pomocny-text-podprogramy">

          {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu)}}
        </div>

      </div>
    </ng-template>

  </ng-template>

</div>
